import { baseUrl, notify } from "./index";
import moment from "moment";
import {
  getToken,
  getUser,
  cacheResponse,
  retreiveCachedResponse
} from "./storage";

export const machineStatuses = ["Available", "Issue", "Missing", "On Hire"];

export const inspectionPriority = ["None", "Low", "Medium", "High"];

export const inspectionPrioritySelect = inspectionPriority.map(priority => ({
  label: priority,
  value: priority
}));

export const machineStatusesSelect = machineStatuses.map(status => ({
  label: status,
  value: status
}));

export async function searchMachines(machine_code) {
  let token = await getToken();
  let response = await (await fetch(`${baseUrl}/search/machines`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      machine_code
    })
  })).json();
  // Convert to format react-select wants
  let mappedResponse = response.data.data.map(({ id, code }) => ({
    value: id,
    label: code
  }));
  return mappedResponse;
}

export async function getFormsForMachine(machine_id) {
  let token = await getToken();
  let history = [];

  try {
    let response = await (await fetch(
      `${baseUrl}/machines/inspection_history/${machine_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )).json();

    history = response.data;
    cacheResponse(`getFormsForMachine:${machine_id}`, history);
  } catch (error) {
    history = await retreiveCachedResponse(`getFormsForMachine:${machine_id}`);
  }
  return history;
}

export async function getStoreMachines(store_id) {
  let token = await getToken();
  let machines = [];

  try {
    let response = await (await fetch(`${baseUrl}/machines`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ store_id })
    })).json();

    machines = response.data;
    cacheResponse(`getStoreMachines:${store_id}`, machines);
  } catch (error) {
    console.error(error);
    machines = await retreiveCachedResponse(`getStoreMachines:${store_id}`);
  }

  return machines;
}

export async function getFormForMachine(formId) {
  let token = await getToken();
  let form = {};
  try {
    let response = await (await fetch(`${baseUrl}/inspections/${formId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })).json();

    response.data.require_swap = Boolean(response.data.require_swap);
    response.data.inspection_pass = Boolean(response.data.inspection_pass);

    form = response.data;
    cacheResponse(`getFormForMachine:${formId}`, form);
  } catch (error) {
    form = await retreiveCachedResponse(`getFormForMachine:${formId}`);
  }

  return form;
}

export async function swapMachineStore(machineId, storeId) {
  let token = await getToken();

  let response = await (await fetch(
    `${baseUrl}/machines/${machineId}/store/${storeId}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )).json();

  return response;
}

export async function getMachine(machineId) {
  let token = await getToken();
  let data = {};
  try {
    const response = await (await fetch(
      `${baseUrl}/machines/machine_id/${machineId}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    )).json();
    data = response.data;
    cacheResponse(`getMachine:${machineId}`, data);
  } catch (err) {
    data = await retreiveCachedResponse(`getMachine:${machineId}`);
  }
  return data;
}

export async function createMachineInspection({
  inspection_note,
  inspection_pass,
  machine_id,
  require_swap,
  store_id,
  status,
  one_way_swap,
  new_machine_id,
  machine_hours,
  priority
}) {
  let response = {};
  let token = await getToken();
  let { id } = await getUser();
  const label = "MACHINE INSPECTION";
  const title = `${inspection_note} - ${new Date().toString()}`;

  const url = `${baseUrl}/inspection/machine/store`;

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      user_id: id,
      store_id,
      inspection_note,
      machines: [
        {
          inspection_note,
          inspection_pass,
          machine_hours,
          one_way_swap,
          new_machine_id,
          test_date: moment().format("YYYY-MM-DD HH:mm:ss"),
          id: machine_id,
          require_swap,
          machine_status: status
        }
      ],
      priority
    })
  };
  try {
    response = await fetch(url, options);
  } catch (error) {
    console.error(error);
    cacheResponse("savedForms", { title, url, options, label }, true);
    notify("Failed to post, added to saved forms", "error");
  }

  return response;
}

export async function getMachineFromBarcode(barcode) {
  console.log("getting token for barcode", barcode);

  let token = await getToken();
  const { data } = await (await fetch(
    `${baseUrl}/machines/barcode/${barcode}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  )).json();
  return data;
}



// WEBPACK FOOTER //
// ./src/backend/machines.js